import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './network-security-testing.css'

const NetworkSecurityTesting = (props) => {
  return (
    <div className="network-security-testing-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Network-Security-Testing - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/network-security-testing"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-network-security">
        <video
          src="https://videos.pexels.com/video-files/3141210/3141210-hd_1280_720_25fps.mp4"
          loop="true"
          muted="true"
          autoPlay="true"
          playbackRate="1"
          className="hero-network-security__video"
        ></video>
        <div className="hero-network-security__overlay"></div>
        <div className="hero-network-security__content">
          <div className="hero-network-security__text">
            <h1 className="hero-title hero-network-security__title">
              Network Security Testing
            </h1>
            <p className="hero-network-security__subtitle hero-subtitle">
              Comprehensive infrastructure assessment to identify
              vulnerabilities across your network perimeter, internal systems,
              and critical services before adversaries exploit them.
            </p>
            <div className="hero-network-security__actions">
              <a href="#contact">
                <div className="hero-network-security__btn btn-accent btn btn-lg">
                  <span>Request Assessment</span>
                </div>
              </a>
              <a href="#deliverables">
                <div className="hero-network-security__btn btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>View Methodology</span>
                </div>
              </a>
            </div>
            <div className="hero-network-security__stats">
              <div className="hero-network-security__stat-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="hero-network-security__stat-icon"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <div className="hero-network-security__stat-content">
                  <span className="hero-network-security__stat-number">
                    100+
                  </span>
                  <span className="hero-network-security__stat-label">
                    Network Assessments
                  </span>
                </div>
              </div>
              <div className="hero-network-security__stat-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="hero-network-security__stat-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
                <div className="hero-network-security__stat-content">
                  <span className="hero-network-security__stat-number">
                    10,000+
                  </span>
                  <span className="hero-network-security__stat-label">
                    Vulnerabilities Identified
                  </span>
                </div>
              </div>
              <div className="hero-network-security__stat-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="hero-network-security__stat-icon"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <div className="hero-network-security__stat-content">
                  <span className="hero-network-security__stat-number">
                    98%
                  </span>
                  <span className="hero-network-security__stat-label">
                    Client Satisfaction
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="features-network-security">
        <div className="features-network-security__container">
          <div className="features-network-security__header">
            <h2 className="features-network-security__title section-title">
              Comprehensive Network Assessment Scope
            </h2>
            <p className="section-subtitle features-network-security__subtitle">
              Our network security testing provides complete visibility into
              your infrastructure security posture through advanced scanning,
              manual validation, and exploitation techniques.
            </p>
          </div>
          <div className="features-network-security__grid">
            <div className="features-network-security__card">
              <div className="features-network-security__icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="features-network-security__icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-network-security__card-title">
                Network Infrastructure Review
              </h3>
              <p className="section-content features-network-security__card-description">
                In-depth analysis of routers, switches, firewalls, load
                balancers, and network segmentation to identify
                misconfigurations and security gaps.
              </p>
            </div>
            <div className="features-network-security__card">
              <div className="features-network-security__icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="features-network-security__icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m21 21l-4.34-4.34"></path>
                      <circle r="8" cx="11" cy="11"></circle>
                    </g>
                  </g>
                </svg>
              </div>
              <h3 className="features-network-security__card-title">
                Vulnerability Discovery
              </h3>
              <p className="section-content features-network-security__card-description">
                Advanced automated and manual testing to uncover CVEs,
                zero-days, configuration weaknesses, and protocol-level
                vulnerabilities across your network.
              </p>
            </div>
            <div className="features-network-security__card">
              <div className="features-network-security__icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="features-network-security__icon"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-network-security__card-title">
                Perimeter Defense Testing
              </h3>
              <p className="section-content features-network-security__card-description">
                External-facing service enumeration, port scanning, and exposure
                analysis to validate firewall rules and identify attack vectors
                visible from the internet.
              </p>
            </div>
            <div className="features-network-security__card">
              <div className="features-network-security__icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="features-network-security__icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-network-security__card-title">
                Internal Network Assessment
              </h3>
              <p className="section-content features-network-security__card-description">
                Insider threat simulation testing lateral movement paths,
                privilege escalation opportunities, and internal segmentation
                controls from a trusted network position.
              </p>
            </div>
            <div className="features-network-security__card">
              <div className="features-network-security__icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="features-network-security__icon"
                >
                  <path
                    d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-network-security__card-title">
                Service Exploitation
              </h3>
              <p className="section-content features-network-security__card-description">
                Real-world exploitation of discovered vulnerabilities to
                demonstrate business impact and validate the severity of
                identified security weaknesses.
              </p>
            </div>
            <div className="features-network-security__card">
              <div className="features-network-security__icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="features-network-security__icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-network-security__card-title">
                Detailed Remediation Guidance
              </h3>
              <p className="section-content features-network-security__card-description">
                Actionable recommendations with step-by-step remediation
                procedures, prioritized by risk, enabling your team to
                efficiently secure your network infrastructure.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="process-network-testing">
        <div className="process-network-testing__container">
          <div className="process-network-testing__header">
            <h2 className="section-title process-network-testing__title">
              Testing Methodologies
            </h2>
            <p className="section-subtitle process-network-testing__subtitle">
              Our multi-layered approach combines automated scanning with manual
              validation to ensure comprehensive coverage and accurate risk
              assessment across your entire network infrastructure.
            </p>
          </div>
          <div className="process-network-testing__grid">
            <div className="process-network-testing__method">
              <div className="process-network-testing__method-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"></path>
                    <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path>
                    <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path>
                  </g>
                </svg>
              </div>
              <div className="process-network-testing__method-content">
                <h3 className="process-network-testing__method-title">
                  External Testing
                </h3>
                <p className="section-content process-network-testing__method-description">
                  Simulates attacks from outside your organization targeting
                  internet-facing infrastructure, testing perimeter defenses,
                  exposed services, and firewall configurations from an
                  attacker&apos;s perspective.
                </p>
                <ul className="process-network-testing__method-list">
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>
                      Public IP range enumeration and service discovery
                    </span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>DMZ and perimeter security validation</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Firewall rule effectiveness testing</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>VPN and remote access security evaluation</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="process-network-testing__method">
              <div className="process-network-testing__method-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <div className="process-network-testing__method-content">
                <h3 className="process-network-testing__method-title">
                  Internal Testing
                </h3>
                <p className="section-content process-network-testing__method-description">
                  Evaluates security from within the network perimeter to
                  identify lateral movement risks, segmentation weaknesses, and
                  insider threat scenarios, mimicking compromised internal
                  assets.
                </p>
                <ul className="process-network-testing__method-list">
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Network segmentation and VLAN security</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Lateral movement path identification</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Active Directory and domain security</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Privilege escalation opportunities</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="process-network-testing__method">
              <div className="process-network-testing__method-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="process-network-testing__method-content">
                <h3 className="process-network-testing__method-title">
                  Active Scanning &amp; Exploitation
                </h3>
                <p className="section-content process-network-testing__method-description">
                  Aggressive scanning techniques combined with real exploitation
                  to validate vulnerabilities, test security controls under
                  attack conditions, and demonstrate actual business impact.
                </p>
                <ul className="process-network-testing__method-list">
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Comprehensive port and service enumeration</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Vulnerability scanner deployment and validation</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Safe exploitation of verified vulnerabilities</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>IDS/IPS detection capability testing</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="process-network-testing__method">
              <div className="process-network-testing__method-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div className="process-network-testing__method-content">
                <h3 className="process-network-testing__method-title">
                  Passive Reconnaissance
                </h3>
                <p className="section-content process-network-testing__method-description">
                  Non-intrusive intelligence gathering using network traffic
                  analysis, DNS enumeration, and open-source intelligence to map
                  infrastructure without triggering security alerts.
                </p>
                <ul className="process-network-testing__method-list">
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Network traffic monitoring and packet capture</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>OSINT and public information discovery</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>DNS and subdomain enumeration</span>
                  </li>
                  <li className="process-network-testing__method-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="process-network-testing__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Certificate transparency log analysis</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="deliverables-network-security">
        <div className="deliverables-network-security__container">
          <div className="deliverables-network-security__header">
            <h2 className="deliverables-network-security__title section-title">
              Engagement Deliverables &amp; Reporting
            </h2>
            <p className="section-subtitle deliverables-network-security__subtitle">
              Receive comprehensive documentation that transforms technical
              findings into actionable intelligence for both security teams and
              executive stakeholders.
            </p>
          </div>
          <div className="deliverables-network-security__timeline">
            <div className="deliverables-network-security__step">
              <div className="deliverables-network-security__step-indicator">
                <span className="deliverables-network-security__step-number">
                  01
                </span>
              </div>
              <div className="deliverables-network-security__step-content">
                <div className="deliverables-network-security__step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <circle r="6" cx="12" cy="12"></circle>
                      <circle r="2" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <h3 className="deliverables-network-security__step-title">
                  Pre-Engagement Planning
                </h3>
                <p className="section-content deliverables-network-security__step-description">
                  Detailed scoping documentation defining IP ranges, testing
                  windows, authorization letters, rules of engagement, and
                  emergency contact procedures to ensure safe and compliant
                  testing.
                </p>
              </div>
            </div>
            <div className="deliverables-network-security__step">
              <div className="deliverables-network-security__step-indicator">
                <span className="deliverables-network-security__step-number">
                  02
                </span>
              </div>
              <div className="deliverables-network-security__step-content">
                <div className="deliverables-network-security__step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m21 21l-4.34-4.34"></path>
                      <circle r="8" cx="11" cy="11"></circle>
                    </g>
                  </svg>
                </div>
                <h3 className="deliverables-network-security__step-title">
                  Active Testing Phase
                </h3>
                <p className="section-content deliverables-network-security__step-description">
                  Continuous communication throughout testing including daily
                  status updates, critical finding alerts, and real-time
                  collaboration for complex exploitation scenarios requiring
                  immediate attention.
                </p>
              </div>
            </div>
            <div className="deliverables-network-security__step">
              <div className="deliverables-network-security__step-indicator">
                <span className="deliverables-network-security__step-number">
                  03
                </span>
              </div>
              <div className="deliverables-network-security__step-content">
                <div className="deliverables-network-security__step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                      <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="deliverables-network-security__step-title">
                  Comprehensive Technical Report
                </h3>
                <p className="section-content deliverables-network-security__step-description">
                  Detailed technical documentation of all findings including
                  vulnerability descriptions, exploitation proof-of-concepts,
                  affected assets, CVSS scoring, and evidence screenshots with
                  reproduction steps.
                </p>
              </div>
            </div>
            <div className="deliverables-network-security__step">
              <div className="deliverables-network-security__step-indicator">
                <span className="deliverables-network-security__step-number">
                  04
                </span>
              </div>
              <div className="deliverables-network-security__step-content">
                <div className="deliverables-network-security__step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                      <path d="m19 9l-5 5l-4-4l-3 3"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="deliverables-network-security__step-title">
                  Risk-Prioritized Remediation Roadmap
                </h3>
                <p className="section-content deliverables-network-security__step-description">
                  Actionable remediation plan categorized by severity with
                  specific fix recommendations, estimated effort levels, and
                  suggested timelines aligned with your business risk tolerance
                  and operational constraints.
                </p>
              </div>
            </div>
            <div className="deliverables-network-security__step">
              <div className="deliverables-network-security__step-indicator">
                <span className="deliverables-network-security__step-number">
                  05
                </span>
              </div>
              <div className="deliverables-network-security__step-content">
                <div className="deliverables-network-security__step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="8"
                        y="2"
                        rx="1"
                        ry="1"
                        width="8"
                        height="4"
                      ></rect>
                      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="deliverables-network-security__step-title">
                  Executive Summary Presentation
                </h3>
                <p className="section-content deliverables-network-security__step-description">
                  Business-focused summary translating technical findings into
                  risk metrics, compliance impact, and strategic recommendations
                  for leadership decision-making and board-level communication.
                </p>
              </div>
            </div>
            <div className="deliverables-network-security__step">
              <div className="deliverables-network-security__step-indicator">
                <span className="deliverables-network-security__step-number">
                  06
                </span>
              </div>
              <div className="deliverables-network-security__step-content">
                <div className="deliverables-network-security__step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="deliverables-network-security__step-title">
                  Post-Remediation Validation
                </h3>
                <p className="section-content deliverables-network-security__step-description">
                  Optional retesting service to verify remediation
                  effectiveness, validate security improvements, and provide
                  closure report confirming vulnerability resolution and
                  security posture enhancement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="report-structure-network-security">
        <div className="report-structure-network-security__container">
          <div className="report-structure-network-security__header">
            <h2 className="report-structure-network-security__title section-title">
              Sample Report Structure
            </h2>
            <p className="section-subtitle report-structure-network-security__subtitle">
              Explore the comprehensive documentation framework that provides
              complete visibility into your network security posture and
              actionable intelligence for remediation.
            </p>
          </div>
          <div className="report-structure-network-security__tabs">
            <div className="report-structure-network-security__tab-buttons">
              <button
                data-tab="executive"
                className="report-structure-network-security__tab-btn--active report-structure-network-security__tab-btn"
              >
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                  className="network-security-testing-thq-report-structure-network-securitytab-icon-elm1"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                  </g>
                </svg>
                <span>Executive Summary</span>
              </button>
              <button
                data-tab="technical"
                className="report-structure-network-security__tab-btn"
              >
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                  className="network-security-testing-thq-report-structure-network-securitytab-icon-elm2"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                  </g>
                </svg>
                <span>Technical Findings</span>
              </button>
              <button
                data-tab="remediation"
                className="report-structure-network-security__tab-btn"
              >
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                  className="network-security-testing-thq-report-structure-network-securitytab-icon-elm3"
                >
                  <path
                    d="M16 5H3m13 7H3m8 7H3m12-1l2 2l4-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Remediation Plan</span>
              </button>
              <button
                data-tab="evidence"
                className="report-structure-network-security__tab-btn"
              >
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                  className="network-security-testing-thq-report-structure-network-securitytab-icon-elm4"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
                <span>Evidence &amp; Metrics</span>
              </button>
            </div>
            <div className="report-structure-network-security__tab-content">
              <div
                data-panel="executive"
                className="report-structure-network-security__tab-panel report-structure-network-security__tab-panel--active"
              >
                <div className="report-structure-network-security__content-layout">
                  <div className="report-structure-network-security__content-text">
                    <h3 className="report-structure-network-security__content-title">
                      Executive Summary
                    </h3>
                    <p className="report-structure-network-security__content-description section-content">
                      Business-focused overview translating technical
                      vulnerabilities into strategic risk insights for
                      leadership and board-level stakeholders.
                    </p>
                    <ul className="report-structure-network-security__content-list">
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Overall security posture assessment and risk rating
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Key findings summary with business impact analysis
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Risk distribution charts and vulnerability heat maps
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Strategic remediation priorities and investment
                          recommendations
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Compliance implications and regulatory considerations
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="report-structure-network-security__content-image">
                    <img
                      alt="Executive dashboard showing security metrics and risk analysis"
                      src="https://images.pexels.com/photos/5380664/pexels-photo-5380664.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                      className="report-structure-network-security__image"
                    />
                  </div>
                </div>
              </div>
              <div
                data-panel="technical"
                className="report-structure-network-security__tab-panel"
              >
                <div className="report-structure-network-security__content-layout">
                  <div className="report-structure-network-security__content-text">
                    <h3 className="report-structure-network-security__content-title">
                      Technical Findings
                    </h3>
                    <p className="report-structure-network-security__content-description section-content">
                      Detailed vulnerability documentation with exploitation
                      proof-of-concepts, CVSS scoring, and comprehensive
                      technical analysis for security teams.
                    </p>
                    <ul className="report-structure-network-security__content-list">
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Vulnerability descriptions with CVE references
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Step-by-step exploitation procedures and reproduction
                          steps
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Screenshots, packet captures, and technical evidence
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Affected asset inventory with IP addresses and
                          services
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Attack path visualization and exploitation chains
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="report-structure-network-security__content-image">
                    <img
                      alt="Security analysts reviewing technical vulnerability findings"
                      src="https://images.pexels.com/photos/5380655/pexels-photo-5380655.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                      className="report-structure-network-security__image"
                    />
                  </div>
                </div>
              </div>
              <div
                data-panel="remediation"
                className="report-structure-network-security__tab-panel"
              >
                <div className="report-structure-network-security__content-layout">
                  <div className="report-structure-network-security__content-text">
                    <h3 className="report-structure-network-security__content-title">
                      Remediation Plan
                    </h3>
                    <p className="report-structure-network-security__content-description section-content">
                      Prioritized action plan with specific fix recommendations,
                      implementation guidance, and timeline estimates tailored
                      to your operational environment.
                    </p>
                    <ul className="report-structure-network-security__content-list">
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Critical, high, medium, and low priority
                          categorization
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Detailed remediation procedures for each finding
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Estimated effort levels and resource requirements
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Quick wins and long-term security improvement
                          strategies
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Compliance mapping and regulatory requirement coverage
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="report-structure-network-security__content-image">
                    <img
                      alt="Engineer implementing remediation procedures in server environment"
                      src="https://images.pexels.com/photos/1181354/pexels-photo-1181354.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                      className="report-structure-network-security__image"
                    />
                  </div>
                </div>
              </div>
              <div
                data-panel="evidence"
                className="report-structure-network-security__tab-panel"
              >
                <div className="report-structure-network-security__content-layout">
                  <div className="report-structure-network-security__content-text">
                    <h3 className="report-structure-network-security__content-title">
                      Evidence &amp; Metrics
                    </h3>
                    <p className="report-structure-network-security__content-description section-content">
                      Comprehensive documentation package including technical
                      evidence, metrics dashboards, and appendices supporting
                      all findings and conclusions.
                    </p>
                    <ul className="report-structure-network-security__content-list">
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>Screenshot library with annotated evidence</span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>Network diagrams and infrastructure mapping</span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>Tool output logs and scan result exports</span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Risk trend analysis and historical comparison data
                        </span>
                      </li>
                      <li className="report-structure-network-security__content-list-item">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                          className="report-structure-network-security__list-icon"
                        >
                          <path
                            d="M20 6L9 17l-5-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span>
                          Glossary, methodology appendix, and reference
                          materials
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="report-structure-network-security__content-image">
                    <img
                      alt="Data center infrastructure showing monitored security metrics"
                      src="https://images.pexels.com/photos/17489156/pexels-photo-17489156.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                      className="report-structure-network-security__image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="compliance-network-security">
        <div className="compliance-network-security__container">
          <div className="compliance-network-security__header">
            <h2 className="compliance-network-security__title section-title">
              Regulatory &amp; Standards Compliance
            </h2>
            <p className="section-subtitle compliance-network-security__subtitle">
              Our network security testing methodology aligns with international
              standards and regulatory frameworks, ensuring your assessments
              meet compliance requirements and audit expectations.
            </p>
          </div>
          <div className="compliance-network-security__grid">
            <div className="compliance-network-security__standard">
              <div className="compliance-network-security__standard-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-network-security__standard-title">
                PCI-DSS
              </h3>
              <p className="section-content compliance-network-security__standard-description">
                Payment Card Industry Data Security Standard compliance
                validation including quarterly network scans, segmentation
                testing, and cardholder data environment security controls
                verification.
              </p>
            </div>
            <div className="compliance-network-security__standard">
              <div className="compliance-network-security__standard-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-network-security__standard-title">
                NIST SP 800-115
              </h3>
              <p className="section-content compliance-network-security__standard-description">
                Technical Guide to Information Security Testing and Assessment
                framework adherence ensuring comprehensive coverage of network
                security testing techniques and methodologies.
              </p>
            </div>
            <div className="compliance-network-security__standard">
              <div className="compliance-network-security__standard-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-network-security__standard-title">
                ISO 27001
              </h3>
              <p className="section-content compliance-network-security__standard-description">
                Information Security Management System requirements including
                A.12.6 Technical Vulnerability Management and A.18 System
                Acquisition, Development and Maintenance controls validation.
              </p>
            </div>
            <div className="compliance-network-security__standard">
              <div className="compliance-network-security__standard-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-network-security__standard-title">
                CIS Controls
              </h3>
              <p className="section-content compliance-network-security__standard-description">
                Center for Internet Security Critical Security Controls
                alignment focusing on network infrastructure hardening,
                continuous vulnerability management, and security monitoring
                capabilities.
              </p>
            </div>
            <div className="compliance-network-security__standard">
              <div className="compliance-network-security__standard-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-network-security__standard-title">
                SOC 2 Type II
              </h3>
              <p className="section-content compliance-network-security__standard-description">
                Service Organization Control security criteria testing
                supporting Trust Services Criteria including security,
                availability, and confidentiality principle verification through
                independent assessment.
              </p>
            </div>
            <div className="compliance-network-security__standard">
              <div className="compliance-network-security__standard-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M3 3v16a2 2 0 0 0 2 2h16m-3-4V9m-5 8V5M8 17v-3"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="compliance-network-security__standard-title">
                HIPAA Security Rule
              </h3>
              <p className="section-content compliance-network-security__standard-description">
                Health Insurance Portability and Accountability Act technical
                safeguards assessment including network transmission security,
                access controls, and audit logging for protected health
                information.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="network-security-testing-thq-cta-network-security-elm cta-network-security">
        <div className="cta-network-security__container">
          <div className="network-security-testing-thq-cta-network-securitycard-elm cta-network-security__card">
            <div className="cta-network-security__icon-wrapper">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewBox="0 0 24 24"
                className="cta-network-security__icon"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <h2 className="section-title cta-network-security__title">
              Secure Your Network Infrastructure Today
            </h2>
            <p className="cta-network-security__description section-content">
              Partner with our expert security team to identify and remediate
              network vulnerabilities before attackers exploit them. Get a
              comprehensive assessment that provides actionable intelligence and
              measurable risk reduction.
            </p>
            <div className="cta-network-security__actions">
              <a href="#contact">
                <div className="network-security-testing-thq-btn-elm3 btn-xl btn-accent btn cta-network-security__btn">
                  <span>Request Assessment</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="network-security-testing-container2">
        <div className="network-security-testing-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.features-network-security__card, .process-network-testing__method, .compliance-network-security__standard, .faq-network-security__icon {
  transition: none;
}
.features-network-security__card:hover, .process-network-testing__method:hover, .compliance-network-security__standard:hover {
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="network-security-testing-container4">
        <div className="network-security-testing-container5">
          <Script
            html={`<script defer data-name="tabs-functionality">
(function(){
  const tabButtons = document.querySelectorAll(".report-structure-network-security__tab-btn")
  const tabPanels = document.querySelectorAll(".report-structure-network-security__tab-panel")

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetTab = button.getAttribute("data-tab")

      tabButtons.forEach((btn) => btn.classList.remove("report-structure-network-security__tab-btn--active"))
      tabPanels.forEach((panel) => panel.classList.remove("report-structure-network-security__tab-panel--active"))

      button.classList.add("report-structure-network-security__tab-btn--active")

      const targetPanel = document.querySelector(\`[data-panel="\${targetTab}"]\`)
      if (targetPanel) {
        targetPanel.classList.add("report-structure-network-security__tab-panel--active")
      }
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default NetworkSecurityTesting
